export const requestUserPermission = async () => true
